import { UIBox, UITypography, UIButton } from '@workspace/ui/composed';
import { User, Monitor, AppWindow } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslations } from '../../i18n/useTranslations';

interface MenuItem {
  id: string;
  nameKey: string;
  path: string;
  icon: React.ReactNode;
}

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslations('sidebar');

  const menuItems: MenuItem[] = [
    {
      id: 'personal-info',
      nameKey: 'personalInfo',
      path: '/',
      icon: <User className="h-5 w-5" />
    },
    {
      id: 'sessions',
      nameKey: 'sessions',
      path: '/sessions',
      icon: <Monitor className="h-5 w-5" />
    },
    {
      id: 'applications',
      nameKey: 'applications',
      path: '/applications',
      icon: <AppWindow className="h-5 w-5" />
    }
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <UIBox className="h-full overflow-auto bg-card">
      <UIBox className="pt-2">
        {menuItems.map(menu => (
          <UIButton
            key={menu.id}
            variant="ghost"
            onClick={() => navigate(menu.path)}
            className={`w-full flex items-center justify-start gap-3 px-4 py-3 h-auto rounded-none ${
              isActive(menu.path)
                ? 'bg-primary/10 text-primary border-r-2 border-primary'
                : 'text-muted-foreground'
            }`}
          >
            {menu.icon}
            <UITypography variant="p" className="text-sm font-medium">
              {t(menu.nameKey)}
            </UITypography>
          </UIButton>
        ))}
      </UIBox>
    </UIBox>
  );
}

export default Sidebar;
